// React
import { Container, Row, Col, Card, Image, Button  } from "react-bootstrap";
import { useState } from "react";

// Assets
import ownersImg1 from "../../assets/images/about/owners.jpg";
import ownersImg2 from "../../assets/images/about/owners2.jpg";
import ownersImg3 from "../../assets/images/about/owners3.jpg";
import "../../assets/styles/about.css";

// Hooks
import { useTranslation } from "../../hooks/useTranslation";

export default function Owners() {
  const t = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    { src: ownersImg1, alt: "Roland & Daniella – 1" },
    { src: ownersImg2, alt: "Roland & Daniella – 2" },
    { src: ownersImg3, alt: "Roland & Daniella – 3" },
  ];

  const prevImage = () =>
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const nextImage = () =>
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div className="owners-section-wrapper">
      <Container className="owners-section">
        <Row className="justify-content-center owner-row">
          <Col xs={12} md={8} lg={6} className="owner-col">
            <div className="owner-card-wrapper">
              <Card className="owner-card">
                <div className="owner-carousel-wrapper">
                  <Image
                    src={images[currentIndex].src}
                    alt={images[currentIndex].alt}
                    className="owner-photo"
                    fluid
                  />
                  {images.length > 1 && (
                    <>
                      <Button
                        variant="light"
                        className="carousel-btn left"
                        onClick={prevImage}
                      >
                        ‹
                      </Button>
                      <Button
                        variant="light"
                        className="carousel-btn right"
                        onClick={nextImage}
                      >
                        ›
                      </Button>
                    </>
                  )}
                </div>
                <Card.Body>
                  <Card.Text className="owner-text">
                    {t("about.team")}
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="text-row">
          <Col className="text-col" lg={{ span: 10, offset: 1 }}>
            <p className="text-col-p">{t("about.familyAtmosphere")}</p>
            <p className="text-col-p">{t("about.groupClasses")}</p>
            <p className="text-col-p">{t("about.membership")}</p>
            <p className="text-col-p">{t("about.philosophy")}</p>
            <p className="invitation-text">{t("about.invitation")}</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}